import { fetchJSON } from "@/api/utils.js";

function generateTimestamps(days, startDate = new Date()) {
  const timestamps = [];
  for (let i = 0; i < days; i++) {
    const date = new Date(startDate);
    date.setDate(startDate.getDate() + i); // Increment the day by i
    timestamps.push(date.getTime());
  }
  return timestamps;
}

function getRandomTimeInSeconds(maxHours = 23, maxMinutes = 59) {
  const hours = Math.floor(Math.random() * (maxHours + 1));
  const minutes = Math.floor(Math.random() * (maxMinutes + 1));
  return hours * 3600 + minutes * 60;
}

function waitFor(ms = 200) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

const buildUrl = (path) => {
  if (!import.meta.env.VITE_APP_ANALYTICS_SERVER_URL) return path;

  const url = new URL(path, import.meta.env.VITE_APP_ANALYTICS_SERVER_URL);
  return url.toString();
}

/*
export async function fetchAnalytics(params) {
  const url = `/api/analytics`;
  return fetchJSON(`/api/analytics/trainings_overview`, params, null, "get")
    .catch(() => ({}));
}
*/

export function fetchRecommendations(params) {
  const url = buildUrl("/api/recommendations/");
  return fetchJSON(url, params, null, "get")
    .catch(() => ({}));
}

export function fetchAIAnalytics(params) {
  const url = buildUrl("/api/analytics/ai_analytics");
  return fetchJSON(url, params, null, "get");
}

export function fetchReferencedContent(params) {
  const url = buildUrl("/api/analytics/referenced_content");
  return fetchJSON(url, params, null, "get")
    .catch(() => ({}));
}
export function fetchTrainingsOverview(params) {
  const url = buildUrl("/api/analytics/trainings_overview");
  return fetchJSON(url, params, null, "get")
    .catch(() => ({}));
}
export function fetchTrainingsByDepartment(params) {
  const url = buildUrl("/api/analytics/trainings_by_department");
  return fetchJSON(url, params, null, "get")
    .catch(() => ({}));
}


export function fetchAnalyticsSummary(params) {
  const url = buildUrl("/api/analytics/summary");
  return fetchJSON(url, params, null, "get")
    .catch(() => ({}));
}

export function fetchAnalyticsSummaryMulti(params) {
  const url = buildUrl("/api/analytics/summary_multiorg");
  return fetchJSON(url, params, null, "get")
    .catch(() => ({}));
}

export function fetchAnalyticsTicketsMulti(params) {
  const url = buildUrl("/api/analytics/summary_ticket_multiorg");
  return fetchJSON(url, params, null, "get")
    .catch(() => ({}));
}

export function fetchAnalyticsTrainingVsSupportMulti(params) {
  const url = buildUrl("/api/analytics/training_vs_support_stats_multi");
  return fetchJSON(url, params, null, "get")
    .catch(() => ({}));
}

export function fetchAnalyticsSummaryNoFilter(params) {
  const url = buildUrl("/api/analytics/summary");
  return fetchJSON(url, params, null, "get")
    .catch(() => ({}));
}

export function fetchAnalyticsSummaryTimeseries(params) {
  const url = buildUrl("/api/analytics/summary_timeseries");
  return fetchJSON(url, params, null, "get")
    .catch(() => ({}));
}


export function fetchAnalyticsActiveUsers(params) {
  const url = buildUrl("/api/analytics/active_users");
  return fetchJSON(url, params, null, "get")
    .catch(() => ({}));
}

export function fetchAnalyticsActiveUnits(params) {
  const url = buildUrl("/api/analytics/active_units");
  return fetchJSON(url, params, null, "get")
    .catch(() => ({}));
}

export function fetchAnalyticsSupportVsAgentTimeseries(params) {
  const url = buildUrl("/api/analytics/support_vs_agent_timeseries");
  return fetchJSON(url, params, null, "get")
    .catch(() => ({}));
}

export function fetchAnalyticsSupportAgentFeedback(params) {
  const url = buildUrl("/api/analytics/support_agent_feedback");
  return fetchJSON(url, params, null, "get")
    .catch(() => ({}));
}

export function fetchAnalyticsVirtualAgentFeedback(params) {
  const url = buildUrl("/api/analytics/virtual_agent_feedback");
  return fetchJSON(url, params, null, "get")
    .catch(() => ({}));
}

export function fetchAnalyticsVirtualAgentFeedbackMulti(params) {
  const url = buildUrl("/api/analytics/multi_virtual_agent_feedback");
  return fetchJSON(url, params, null, "get")
    .catch(() => ({}));
}

export function fetchAnalyticsMostActiveUnitsMulti(params) {
  const url = buildUrl("/api/analytics/multi_active_units");
  return fetchJSON(url, params, null, "get")
    .catch(() => ({}));
}

export function fetchAnalyticsMostActiveUsersMulti(params) {
  const url = buildUrl("/api/analytics/multi_active_users");
  return fetchJSON(url, params, null, "get")
    .catch(() => ({}));
}

export function changeSubGapStatus(subGapId, status) {
  const url = buildUrl(`/api/analytics/ai_analytics/subgap/${subGapId}/status/${status}`);
  return fetchJSON(url, null, null, "post");
}
